import { runInAction } from 'mobx';
import { createFetchedData } from '../../../utils/fetched-data/create-fetched-data';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { journeyDomainStore } from '../../journey/store';
export const setJourneyList = (journeys) => {
    runInAction(() => {
        journeys.forEach(journey => {
            journeyDomainStore.data.journeysById[journey.id] = createFetchedData(journey, getCacheDuration('journeys'));
        });
    });
};
